<template>
    <v-container fluid style="margin: 0px">
        <v-card
            elevation="0"
            style="
                margin-top: 0px !important;
                margin-bottom: -30px !important;
                overflow: hidden;
                background-color: transparent;
            "
            class="px-5 py-1"
        >
            <v-row class="custom-gray-background fill-width d-flex" v-if="mostrarFiltro">
                <v-col cols="12" sm="6" md="3">
                    <span>Empresa</span>
                    <v-select v-model="selectedUnidade" :items="unidadesOptions" label="Empresa" dense
                        solo-inverted item-text="text" item-value="value" class="compact-field" />
                </v-col>

                <v-col cols="12" sm="6" md="3">
                    <span>Entidade</span>
                    <v-select v-model="selectedEntidade" :items="entidadesDisponiveis"
                        label="Entidade" dense solo-inverted item-text="text" item-value="value"
                        class="compact-field" />
                </v-col>

                <v-col cols="12" sm="6" md="3" v-if="selectedEntidade === 'TIC'">
                    <span>Subentidade</span>
                    <v-select v-model="selectedSubentidade" :items="ticSubOptions"
                        label="Subentidade" dense solo-inverted item-text="text" item-value="value"
                        class="compact-field"  />
                </v-col>

                <v-col cols="12" sm="6" md="3">
                    <span>Período - Inicial</span>
                    <v-menu v-model="isStartOpen" :close-on-content-click="false" transition="scale-transition"
                        offset-y>
                        <template #activator="{ on }">
                            <v-text-field v-model="startBR" label="Data Inicial" dense solo-inverted readonly
                                class="compact-field" v-on="on" />
                        </template>
                        <v-date-picker no-title v-model="startISO" @input="onPickStart" />
                    </v-menu>
                </v-col>

                <v-col cols="12" sm="6" md="3">
                    <span>Período - Final</span>
                    <v-menu v-model="isEndOpen" :close-on-content-click="false" transition="scale-transition" offset-y>
                        <template #activator="{ on }">
                            <v-text-field v-model="endBR" label="Data Final" dense solo-inverted readonly
                                class="compact-field" v-on="on" />
                        </template>
                        <v-date-picker no-title v-model="endISO" @input="onPickEnd" />
                    </v-menu>
                </v-col>
            </v-row>

            <v-divider></v-divider>

            <v-card-actions class="justify-end">
                <v-btn
                    @click="alternarVisibilidade"
                    color="#4682B4"
                    small
                    class="mr-2"
                    style="font-size: 14px !important; font-weight: bold"
                >
                    {{ mostrarFiltro ? "Ocultar Filtro" : "Mostrar Filtro" }}
                    <v-icon style="margin-left: 8px" dark>
                        {{ mostrarFiltro ? "mdi-eye-off" : "mdi-eye" }}
                    </v-icon>
                </v-btn>

                <v-btn 
                    @click="emitLimpar" 
                    v-if="mostrarFiltro"
                    color="#4682B4" 
                    small 
                    outlined 
                    class="mr-2"
                    style="font-size: 14px !important; font-weight: bold"
                >
                    Limpar
                </v-btn>
                <v-btn 
                    @click="emitFiltrar" 
                    v-if="mostrarFiltro"
                    color="#4682B4" 
                    small 
                    style="font-size: 14px !important; font-weight: bold"
                    :disabled="!startISO || !endISO || !selectedEntidade || !selectedUnidade"
                >
                    Filtrar <v-icon style="margin-left: 8px" dark>mdi-filter</v-icon>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
export default {
    name: 'FiltroGLPI',
    props: {
        calendar: { type: String, default: 'mes' },
        valueStartISO: { type: String, default: '' },
        valueEndISO: { type: String, default: '' },
        entidadeMasterOptions: { type: Array, default: () => [] },
        relacionamentoSubOptions: { type: Array, default: () => [] },
        ticSubOptions: { type: Array, default: () => [] },
        valueEntidadeMaster: { type: [String, Number, null], default: null },
        valueRelacionamento: { type: [Number, null], default: null },
        valueTic: { type: [Number, null], default: null }
    },
    data() {
        return {
            mostrarFiltro: true,
            isStartOpen: false,
            isEndOpen: false,
            startISO: '',
            endISO: '',
            startBR: '',
            endBR: '',
            selectedUnidade: null,
            selectedEntidade: null,
            selectedSubentidade: null
        }
    },
    created() {
        const initStart = this.valueStartISO || this.getDefaultStartISO()
        const initEnd = this.valueEndISO || this.getDefaultEndISO()
        this.setStart(initStart)
        this.setEnd(initEnd)
        // Inicializa unidade e entidade baseado nos valores recebidos
        if (this.valueRelacionamento) {
            this.selectedUnidade = this.valueRelacionamento
            this.selectedEntidade = 'REL'
        } else if (this.valueTic) {
            // valueTic agora representa a subentidade de TI
            // TI não precisa de unidade específica
            this.selectedUnidade = null
            this.selectedEntidade = 'TIC'
            this.selectedSubentidade = this.valueTic
        } else if (this.valueEntidadeMaster && typeof this.valueEntidadeMaster === 'number') {
            // Se for uma entidade numérica sem unidade específica, deixa null
            this.selectedUnidade = null
            this.selectedEntidade = null
        }
    },
    computed: {
        unidadesOptions() {
            // Apenas unidades de Relacionamento (removido TIC)
            const relacionamento = (this.relacionamentoSubOptions || []).map(opt => ({
                text: opt.text,
                value: opt.value,
                tipo: 'REL'
            }))
            
            // Aplica filtro de permissões
            return relacionamento.filter(unidade => this.hasPermission(unidade.text))
        },
        entidadesDisponiveis() {
            // Se não houver unidade selecionada, mostra apenas TI
            if (!this.selectedUnidade) {
                return [{ text: 'TI', value: 'TIC' }]
            }
            
            // Se houver unidade, mostra TI e Relacionamento
            const entidades = [
                { text: 'TI', value: 'TIC' },
                { text: 'Relacionamento', value: 'REL' }
            ]
            
            // Pode adicionar outras entidades do entidadeMasterOptions se necessário
            const outrasEntidades = (this.entidadeMasterOptions || []).filter(e => 
                e.value !== 'REL' && e.value !== 'TIC'
            )
            
            return [...entidades, ...outrasEntidades]
        }
    },
    watch: {
        selectedUnidade(val) {
            // Quando a unidade muda, limpa a entidade e subentidade
            this.selectedEntidade = null
            this.selectedSubentidade = null
        },
        selectedEntidade(val) {
            // Quando a entidade muda, limpa a subentidade
            if (val !== 'TIC') {
                this.selectedSubentidade = null
            }
        }
    },
    methods: {
        alternarVisibilidade() {
            this.mostrarFiltro = !this.mostrarFiltro;
        },
        emitFiltrar() {
            this.$emit('filtrar', {
                dataInicioISO: this.startISO || '',
                dataFimISO: this.endISO || '',
                entityId: this.getEntityId()
            })
        },
        emitLimpar() {
            this.selectedUnidade = null
            this.selectedEntidade = null
            this.selectedSubentidade = null
            this.$emit('limpar')
        },
        onPickStart(val) {
            this.setStart(val)
            this.isStartOpen = false
        },
        onPickEnd(val) {
            this.setEnd(val)
            this.isEndOpen = false
        },
        setStart(iso) {
            this.startISO = iso || ''
            this.startBR = iso ? this.convertToBR(iso) : ''
        },
        setEnd(iso) {
            this.endISO = iso || ''
            this.endBR = iso ? this.convertToBR(iso) : ''
        },
        // defaults parecidos com FiltroGeral
        getDefaultStartISO() {
            if (this.calendar === 'ano') return this.firstDayOfYearISO()
            if (this.calendar === 'quinzena' || this.calendar === 'dia' || this.calendar === 'mes' || this.calendar == null)
                return this.firstDayOfMonthISO()
            if (this.calendar === 'decadas') return this.firstDayOf60YearsAgoISO()
            return this.firstDayOfMonthISO()
        },
        getDefaultEndISO() {
            if (this.calendar === 'quinzena') return this.endDateWithOffsetISO(15)
            if (this.calendar === 'dia') return this.todayISO()
            if (this.calendar === 'mes' || this.calendar == null) return this.lastDayOfMonthISO()
            return this.todayISO()
        },
        getEntityId() {
            // Se TI estiver selecionado e houver uma subentidade, retorna a subentidade
            if (this.selectedEntidade === 'TIC' && this.selectedSubentidade) {
                return this.selectedSubentidade
            }
            
            // Se Relacionamento estiver selecionado, retorna a unidade
            if (this.selectedEntidade === 'REL' && this.selectedUnidade) {
                return this.selectedUnidade
            }
            
            // Caso seja uma entidade numérica direta
            if (this.selectedEntidade && typeof this.selectedEntidade === 'number') {
                return this.selectedEntidade
            }
            
            return null
        },
        convertToBR(iso) {
            const [y, m, d] = String(iso).split('-')
            return `${d}/${m}/${y}`
        },
        todayISO() {
            const d = new Date()
            return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
        },
        firstDayOfMonthISO() {
            const d = new Date(); d.setDate(1)
            return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`
        },
        lastDayOfMonthISO() {
            const d = new Date(); const last = new Date(d.getFullYear(), d.getMonth() + 1, 0)
            return `${last.getFullYear()}-${String(last.getMonth() + 1).padStart(2, '0')}-${String(last.getDate()).padStart(2, '0')}`
        },
        firstDayOfYearISO() {
            const d = new Date(); return `${d.getFullYear()}-01-01`
        },
        firstDayOf60YearsAgoISO() {
            const d = new Date(); const y = d.getFullYear() - 60; return `${y}-01-01`
        },
        endDateWithOffsetISO(offsetDays) {
            const now = new Date(); const first = new Date(now.getFullYear(), now.getMonth(), 1)
            const end = new Date(first); end.setDate(end.getDate() + offsetDays)
            return `${end.getFullYear()}-${String(end.getMonth() + 1).padStart(2, '0')}-${String(end.getDate()).padStart(2, '0')}`
        },
        hasPermission(unidadeNome) {
            // Obtém o usuário do sessionStorage
            const user = JSON.parse(sessionStorage.getItem('user'))
            
            if (!user || !user.roles) {
                return false
            }
            
            // Admin tem acesso a tudo
            if (user.roles.includes('ROLE_ADMIN')) {
                return true
            }
            
            // TIC tem acesso a todas as unidades TIC
            if (user.roles.includes('ROLE_TIC')) {
                const ticUnidades = ['TI', 'Suporte iVertex', 'Suporte WK Radar', 'Gestão TIC', 'LGPD']
                if (ticUnidades.includes(unidadeNome)) {
                    return true
                }
            }
            
            // Converte o nome da unidade para o formato da role
            // Ex: "Parque das Flores" -> "ROLE_PARQUE_DAS_FLORES"
            const requiredRole = 'ROLE_' + unidadeNome.trim().toUpperCase().replace(/\s/g, '_')
            
            return user.roles.includes(requiredRole)
        }

    }
}
</script>

